// extracted by mini-css-extract-plugin
export default {"AppsList":"AppsList_AppsList__8Ikwy","DisableShrinkOnMobile":"AppsList_DisableShrinkOnMobile__-o+2H"};